import * as React from "react";
import axios from 'axios';
import useSnackbarAlert from '../../../utils/snackbarHandlers';
import { ContactListRendererProps } from ".";

interface ContactListGetterChildren {
  (data: ContactListRendererProps): React.ReactNode;
}

interface ContactListGetterProps {
  children: ContactListGetterChildren;
}

const ContactListGetter: React.FC<ContactListGetterProps> = ({ children }) => {
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
  const [loading, setLoading] = React.useState<boolean>(false);
  const [contactUsData, setContactUsData] = React.useState<Array<any>>([]);
  const [totalCount, setTotalCount] = React.useState<number>(0);
  const { showErrorMessage } = useSnackbarAlert();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [refreshTable, setRefreshTable] = React.useState<number>(0);

  React.useEffect(() => {
    setLoading(true);
    const payload = {
      pageNumber: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      status: ["NEW", "RESOLVED", "ISSUE"]
    }
    axios.post(`${apiBaseURL}/api/contact/fetchContacts`, payload)
      .then((res: any) => {
        setContactUsData(res?.data?.contactUs)
        setTotalCount(res?.data?.totalRecords)
      })
      .catch((error: Error) => showErrorMessage(error))
      .finally(() => setLoading(false));
  }, [paginationModel, refreshTable]);

  return (
    <React.Fragment>
      {children({
        contactUsData,
        totalCount,
        loading,
        paginationModel,
        setPaginationModel,
        setRefreshTable,
      })}
    </React.Fragment>
  );
};

export default ContactListGetter;
